import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";
import { routes } from "@/routes/utils";
import { useNavigate } from "react-router-dom";
import { useGetRoles } from "@/services";

const useCategory = () => {
  const isMobile = useIsMobile();
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate();

  const { data: roleList, isLoading: isLoadingRoles } = useGetRoles();

  // Define Table Columns
  const columns = [
    {
      accessorKey: "roleId",
      header: "ID",
      accessorFn: (row: any) => String(row?.roleId || ""),
    },
    {
      accessorKey: "name",
      header: "Name",
      accessorFn: (row: any) => String(row?.name || ""),
    },
    {
      accessorKey: "description",
      header: "Description",
      accessorFn: (row: any) => String(row?.description || ""),
    },
  ];

  const onAdd = () => {
    navigate(`${routes.add}`);
  };

  return {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    roleList,
    isLoadingRoles,
  };
};
export default useCategory;
